'use strict';

bbw.service.PostProviderSvc = Class({

    $inject: ['$injector', 'modelFactory'],

    construct: function($injector, modelFactory) {
        this.$injector = $injector;
        this._modelFactory = modelFactory;
    },

    makeWallManager: function() {
        return this.$injector.instantiate(bbw.model.Wall);
    },

    makeForumManager: function() {
        return this.$injector.instantiate(bbw.model.Forum);
    },

    makeBlogManager: function() {
        return this.$injector.instantiate(bbw.model.Blog);
    },

    makeFeedManager: function(isAllMode, filter) {
        var feed = this.$injector.instantiate(bbw.model.Feed);
        feed.setAll(isAllMode, filter);
        return feed;
    },

    makeGlobalFeedManager: function() {
        var feed = this.$injector.instantiate(bbw.model.Feed);
        feed.setGlobal(true);
        return feed;
    },

    makeWallPostManager: function() {
        return this.$injector.instantiate(bbw.model.WallPost);
    },

    makeForumPostManager: function() {
        return this.$injector.instantiate(bbw.model.ForumPost);
    },

    makeBlogPostManager: function() {
        return this.$injector.instantiate(bbw.model.BlogPost);
    },

    makeWallPost: function() {
        return this._makePost('wall');
    },

    makeForumPost: function() {
        return this._makePost('forum');
    },

    makeBlogPost: function() {
        return this._makePost('blog');
    },

    _makePost: function(type_name, args) {
        return this._modelFactory.create(bbw.model.Post).merge(angular.extend(args || {}, {
            'type_name': type_name,
            'is_own': true
        }));
    },

    makeComment: function(post, replyTo) {
        return this._modelFactory.create(bbw.model.Comment).setPost(post).setReplyTo(replyTo).merge({
            'is_own': true
        });
    },

    makePostEditor: function(post, token) {
        return this.makeEditor(post, bbw.model.Post, token);
    },

    makeCommentEditor: function(comment, token) {
        return this.makeEditor(comment, bbw.model.Comment, token);
    },

    makeEditor: function(entity, entityClass, token) {
        if (!(entity instanceof entityClass)) {
            throw new Error("entity class mismatch");
        }
        var postEditor = this.$injector.instantiate(bbw.service.PostEditor);
        postEditor.setEntity(entity);
        postEditor.setCsrfToken(token);
        return postEditor;
    }

});
